"use client"

import { useEffect, useState } from "react"
import { useLocale } from "next-intl"

// The sign-in page is tenant-agnostic (one deployment for CF-SaaS and ColdX
// customers), so both legal worlds are linked: ColdFire-CRM terms for CF and
// the COLDX NETWORK LLC AGB/AVV for CX customers.
const LINKS = {
  de: [
    { label: "AGB (ColdFire)", href: "https://coldfire-crm.com/de/terms" },
    { label: "AGB (ColdX)", href: "https://coldx.io/agb-auftraggeber" },
    { label: "AVV (ColdX)", href: "https://coldx.io/avv" },
    { label: "Datenschutz", href: "https://coldfire-crm.com/de/privacy-policy" },
    { label: "Rückerstattung", href: "https://coldfire-crm.com/de/refund-policy" },
  ],
  en: [
    { label: "Terms (ColdFire)", href: "https://coldfire-crm.com/en/terms" },
    { label: "Terms (ColdX)", href: "https://coldx.io/agb-auftraggeber" },
    { label: "DPA (ColdX)", href: "https://coldx.io/avv" },
    { label: "Privacy", href: "https://coldfire-crm.com/en/privacy-policy" },
    { label: "Refund", href: "https://coldfire-crm.com/en/refund-policy" },
  ],
} as const

export default function AuthFooter() {
  const locale = useLocale()
  const links = locale === "en" ? LINKS.en : LINKS.de
  const year = new Date().getFullYear()
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    const handler = () => setHidden(true)
    window.addEventListener("auth-fire-start", handler)
    return () => window.removeEventListener("auth-fire-start", handler)
  }, [])

  if (hidden) return null

  return (
    <footer className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-white">
      <span>© {year} TE Software Solutions LLC</span>
      <span className="text-white/30">·</span>
      {links.map((link, i) => (
        <span key={link.href} className="flex items-center gap-4">
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors"
          >
            {link.label}
          </a>
          {i < links.length - 1 && <span className="text-white/30">·</span>}
        </span>
      ))}
    </footer>
  )
}
